import React, { useState } from "react"
import MapLocationPicker from "./MapLocationPicker"
import { useSelector } from "react-redux"
import { selectAdData } from "../../../routes/AdForm/adForm.ducks"
import { selectUserInfo } from "../../../routes/Auth/auth.ducks"
import { AutoComplete, Button, Checkbox } from 'antd';
import { useFetchMyLocation } from "./hooks/useFetchMyLocation";
import { useFindByAddress } from "./hooks/useFindByAddress";
import { MultiLevelSelectorWithLogo } from "../../../components/FormControls";
import { getWindowWidth, isMobileScreen } from "../../../services";
import { ModuleName } from "../../../models/enums";
import styles from "./mapLocationPicker.scss"
import { SHOULD_SHOW_OPEN_LAYER_MAPS } from "../../../constants";
import { mapModuleToEn } from "../../../routes/LanguageMapper"

const EMPTY_ID = "00000000-0000-0000-0000-000000000000"
const CROATIA_ID = "1d0ed9f8-c5b3-47f8-8ca1-7feb948d5aef"

// Modules where the "Use profile address" checkbox should be shown
const MODULES_WITH_PROFILE_ADDRESS_CHECKBOX = [ModuleName.realEstate, ModuleName.tourism];

export const LocationSelector = (props) => {
  const { value, onChange } = props;
  const isMobile = isMobileScreen(getWindowWidth());

  const adData = useSelector(selectAdData)
  const userData = useSelector(selectUserInfo)
  const { handleFetchMyLocationClick, isFetchingLocation } = useFetchMyLocation(onChange, value)

  const { findByAddressDebounced, options, handleSelect, autocompleteRef } = useFindByAddress(onChange, value)

  const [isUsingProfileAddress, setIsUsingProfileAddress] = useState(false);

  // Check if we should show the "Use profile address" checkbox
  const shouldShowProfileAddressCheckbox = adData && adData.module &&
    MODULES_WITH_PROFILE_ADDRESS_CHECKBOX.includes(mapModuleToEn(adData.module)) &&
    userData && userData.countryId;

  // Handle filling location from user profile
  const handleUseProfileAddress = (e) => {
    if (e.target.checked && userData) {
      setIsUsingProfileAddress(true);
      onChange({
        ...value,
        countryId: userData.countryId,
        countyId: userData.countyId,
        cityId: userData.cityId,
        settlementId: userData.settlementId,
        latitude: userData.latitude,
        longitude: userData.longitude,
        isPreciseLocation: false
      });
    }
  };

  // Handle when user explicitly changes location - uncheck the profile address checkbox
  const handleLocationChange = (newValue) => {
    setIsUsingProfileAddress(false);
    onChange(newValue);
  };

  const shouldShowMapLocationPicker = SHOULD_SHOW_OPEN_LAYER_MAPS && value &&
    [value.countryId, value.countyId, value.cityId, value.settlementId].every(v => v && v !== EMPTY_ID)

  return (
    <React.Fragment>
      {shouldShowProfileAddressCheckbox && (
        <div style={{ marginBottom: 16 }}>
          <Checkbox
            checked={isUsingProfileAddress}
            disabled={isUsingProfileAddress}
            onChange={handleUseProfileAddress}
          >
            {"Iskoristi adresu iz korisničkog računa"}
          </Checkbox>
        </div>
      )}
      <MultiLevelSelectorWithLogo
        {...props}
        {...props.data}
        onChange={handleLocationChange}
        onError={undefined}
        showPopular
      />

      {(value && value.countryId) === CROATIA_ID && SHOULD_SHOW_OPEN_LAYER_MAPS && (
        <div style={{ marginBottom: 10, marginTop: isMobile ? 10 : 0 }}>
          <div className={styles.locationsAutocomplete}>
            <AutoComplete
              ref={autocompleteRef}
              onSearch={findByAddressDebounced}
              onSelect={handleSelect}
              placeholder="Upiši adresu..."
              size='small'
            >
              {(options || []).map(option => (
                <AutoComplete.Option key={option}>{JSON.parse(option).name}</AutoComplete.Option>
              ))}
            </AutoComplete>
          </div>
          <Button
            onClick={handleFetchMyLocationClick}
            disabled={isFetchingLocation}
            style={{
              display: "inline-block",
              width: isMobile ? "100%" : "calc(50% - 7px)",
              marginLeft: isMobile ? 0 : 7,
              height: 54,
              marginTop: isMobile ? 10 : 0
            }}
          >
            {isFetchingLocation ? "Dohvaćanje lokacije..." : "Dohvati moju lokaciju"}
          </Button>
        </div>
      )}
      {shouldShowMapLocationPicker && (
        <MapLocationPicker
          onChange={props.onChange}
          value={{
            ...value,
            latitude: value.latitude || adData.latitude,
            longitude: value.longitude || adData.longitude,
            isPreciseLocation: value.isPreciseLocation !== undefined ? value.isPreciseLocation : adData.isPreciseLocation,
          }}
        />
      )}
    </React.Fragment>
  )
}




// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/LocationSelector.tsx